import { useMemo } from 'react';
import getBaseColumns from '../utils';
import { videoColumnsFunc } from '../columns/video';
import useLanguage from '@op/hooks/useLanguage';

export function useTrendingColumn({
  language,
  wholeGameInfo,
  renderKey,
  keys,
  statistics,
  navigatePage,
  logBtnId,
  logCommentMap,
  logLoading,
  gameInfo,
  gameMap,
}: {
  renderKey?: string | { origin: string[]; zh: string[]; en: string[]; };
  language: string;
  wholeGameInfo?: any;
  keys: Array<string>;
  statistics: any;
  navigatePage?: any;
  logBtnId?: string;
  logCommentMap?: { [key: string]: string; };
  logLoading?: boolean;
  gameInfo?: any;
  gameMap?: Map<string, { name: string; cover: string; }>;
}) {
  const { formatMessage } = useLanguage();
  const columns = useMemo(() => {
    const columnsMap = videoColumnsFunc({
      formatMessage,
      language,
      wholeGameInfo,
      renderKey,
      statistics,
      navigatePage,
      logBtnId,
      logCommentMap,
      logLoading,
      gameInfo,
      gameMap,
    });
    return getBaseColumns(keys, columnsMap);
  }, [
    formatMessage,
    language,
    renderKey,
    wholeGameInfo,
    keys,
    statistics,
    logCommentMap,
    logLoading,
    gameMap,
  ]);

  return { columns };
}
